import { Box, styled } from '@mui/material';

import { ChkHeader } from '../ChkHeader/ChkHeader';

import type { ChkViewContainerProps } from './ChkViewContainter.types';

export function ChkViewContainer({
  children,
  headerComponentStart,
  headerComponentEnd,
  headerLabel,
  persistentDrawer,
  ...containerProps
}: ChkViewContainerProps) {
  return (
    <RootContainer>
      <ContentContainer {...containerProps}>
        <ChkHeader
          componentStart={headerComponentStart}
          componentEnd={headerComponentEnd}
          component="header"
        >
          {headerLabel}
        </ChkHeader>
        <MainSection>{children}</MainSection>
      </ContentContainer>
      {persistentDrawer}
    </RootContainer>
  );
}

const MainSection = styled('main')({
  display: 'contents',
});

const RootContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  position: 'relative',
});

const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(5, 8),
}));
